import { classNames, formatNumber } from '../../Helpers'

export default function PaginationStats({ pager, className, totalOnly = false }) {
    return (
        <>
            {pager?.total > 0 &&
                <p className={classNames("text-sm text-gray-700 mb-6", className)}>
                    Showing {!totalOnly &&
                        <>
                            <span className="font-medium">{pager.from}</span> to <span className="font-medium">{pager.to}</span> of{' '}
                        </>
                    }
                    <span className="font-medium">{formatNumber(pager.total)}</span> results
                </p>
            }
        </>
    )
}
